import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-zinc-950">
                <div className="flex items-center gap-3 text-zinc-400">
                    <div className="w-2.5 h-2.5 rounded-full bg-orange-500 pulse-glow" />
                    <span className="font-mono text-xs tracking-widest uppercase">Loading FoodGlow360</span>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
